import React, { FC } from 'react';

const Oxidizing: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 170 170"
    fill="none"
    {...props}
  >
    <g clipPath="url(#Oxidizing_1)">
      <path
        fill="#EB1F26"
        d="m163.325 85.09-78.439 78.439-78.44-78.44L84.883 6.65l78.442 78.44Z"
      />
      <path
        stroke="#ED1C24"
        strokeWidth={0.929}
        d="m163.325 85.09-78.439 78.439-78.44-78.44L84.883 6.65l78.442 78.44Z"
      />
      <path
        fill="#fff"
        d="m150.769 85.094-65.885 65.885L19 85.093 84.885 19.21l65.884 65.885Z"
      />
      <mask
        id="Oxidizing_2"
        width={162}
        height={162}
        x={4}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M4.587 165.387h160.596V4.791H4.587v160.596Z" />
      </mask>
      <g mask="url(#Oxidizing_2)">
        <path
          fill="#231F20"
          fillRule="evenodd"
          d="M84.494 107.414c-8.157 0-14.793-6.637-14.793-14.796 0-8.157 6.636-14.796 14.793-14.796 8.159 0 14.796 6.639 14.796 14.796 0 8.159-6.637 14.796-14.796 14.796Zm-19.07-33.252c1.254 1.147 2.61 2.295 4.282 2.608a4.693 4.693 0 0 0 1.532.028 20.782 20.782 0 0 0-5.39 6.952c-.06-1.696-.293-3.901-.527-4.996-.314-1.463-1.147-5.74-1.147-5.74l1.25 1.148Zm7.83-6.368c.417-.94.417-5.22.417-5.22s1.358 5.22 1.67 6.681c.313 1.46.73 2.087 1.252 3.131.226.452.47.72.676.888a20.67 20.67 0 0 0-4.782 2.558c-.285-.64-.728-1.736-.798-2.506-.107-1.148 1.146-4.593 1.565-5.532Zm6.472.73c.313-.94 2.923-5.427 3.027-6.16.105-.728-.104-4.591-.104-4.591s2.086 2.505 3.026 3.757c.939 1.252 1.254 1.567 1.254 2.61s.522 4.175 1.252 6.055c.42 1.08.732 1.838.926 2.297a20.61 20.61 0 0 0-9.436.05c-.073-1.18-.17-3.347.055-4.019Zm15.657-2.61c.27.904 2.259 9.06 2.79 11.252a20.657 20.657 0 0 0-7.37-4.21c.876-1.3 4.283-8.034 4.58-7.042Zm6.368 11.9c.731-.626 3.236-2.086 3.236-2.086s.139 5.498-.208 7.752a63.489 63.489 0 0 1-.552 3.043 20.602 20.602 0 0 0-3.968-7.224c.464-.488 1.132-1.175 1.492-1.485Zm3.078 18.41a227.238 227.238 0 0 0 3.765-4.942c2.427-3.294 3.12-11.79 3.12-13.35 0-1.56-1.04-8.148-1.387-9.19-.346-1.04-.866-3.815-.866-3.815s-.347.695-.52 1.735c-.175 1.04-1.908 2.253-2.602 2.773-.692.522-2.773 1.04-2.773 1.04s.52-3.64.693-4.506c.174-.867 1.387-3.295 1.387-4.681 0-1.387-1.213-5.548-1.213-5.548s-1.04 1.733-2.255 3.12c-1.212 1.388-3.64 1.734-3.64 1.734s1.388-5.028.519-9.016c-.368-1.703-3.64-8.321-3.64-8.321s-.522 3.988-.694 5.028c-.174 1.04-.52 3.121-1.561 4.16-1.04 1.04-3.64 1.388-3.64 1.388s.347-4.683.347-6.935c0-2.256-3.467-10.75-4.162-11.964-.692-1.215-1.213-6.068-1.213-6.068s-.867 3.467-1.387 4.681c-.521 1.214-.693 4.682-.693 6.242 0 1.56 0 4.506-.52 6.588-.52 2.081-1.561 6.762-2.601 6.241-1.04-.52-3.467-5.373-3.64-6.415-.174-1.04-3.642-4.508-3.642-4.508s1.04 2.775 1.04 3.642c0 .866-1.214 2.08-1.733 4.16-.521 2.081-.693 5.03-.172 7.282.519 2.255.345 3.468.345 3.468s-2.624-1.328-3.144-1.847c-.518-.522-2.405-3.007-3.097-4.047-.695-1.041-1.908-2.428-1.908-2.428s1.04 5.201.867 6.415c-.174 1.214.348 6.067.348 7.282 0 1.213 1.038 3.293.172 3.12-.866-.173-7.107-4.855-7.107-4.855s.519 4.162.692 7.11c.173 2.947.521 9.882 1.04 14.91.373 3.609 3.07 6.862 4.561 8.409.776 9.466 7.959 17.141 17.19 18.671H64.383v6.274h42.131v-6.274H87.882c8.605-1.425 15.429-8.189 16.947-16.763Z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Oxidizing_1">
        <path fill="#fff" d="M0 0h170v170H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default Oxidizing
